import React, {useState} from 'react';
import { t } from '../common/LocalizationProvider'

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {makeStyles, Portal, Snackbar, TextField, Typography} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import {useSelector} from "react-redux";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2, 2, 0),
    },
}));


const RemoveDialog = ({ open, password, setPassword, loading, openSnackbar, endpoint, onConfirm,
                          handleRemoveAllNots, handleCloseDialog, handleCloseSnackbar, removeAnyWayMessage, itemId}) => {
    const classes = useStyles();
    const device = useSelector(state => state.devices.items[itemId]);
    const user = useSelector(state => state.session.user);

    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const showedMessage = () => {
        if (endpoint === "devices") {
            if (new Date(device?.expiredAt) < new Date())
                return t('removeAnyWayDialogExpired');
            else if (removeAnyWayMessage === 'removeAnyWayDialog')
                return t('removeAnyWayDialog');
            else
                return t('sharedRemoveBecareful');
        }
        else if (endpoint === "notificationsWS")
            return t('notsWSRemoveAllBecareful')
        else if (endpoint === 'exit')
            return t('exitMessage')
        else
            return t('sharedRemoveConfirm')
    }

    const cancelOrStay = () => {
        if (endpoint === 'exit')
            return t('stay');
        else if (endpoint === 'devices' && (new Date(device?.expiredAt) > new Date() && removeAnyWayMessage === 'removeAnyWayDialog'))
            return t('retry')
        else
            return t('sharedCancel');
    }

    const confirmButtom = () => {
        if (endpoint === "notificationsWS")
            return t('RemoveLast')
        else if (endpoint === 'exit')
            return  t('exit')
        else if (endpoint === 'devices') {
            if (new Date(device?.expiredAt) < new Date() || removeAnyWayMessage === 'removeAnyWayDialog')
                return t('sharedYes')
            else
                return t('sharedRemove')
        }
        else
            return t('sharedRemove')
    }

    const handleCancel = () => {
        if (endpoint === 'devices' && (new Date(device?.expiredAt) > new Date() && removeAnyWayMessage === 'removeAnyWayDialog'))
            onConfirm(false)
        else
            handleCloseDialog(false)
    }

    const handleConfirm = () => {
        if (endpoint === 'devices' && (new Date(device?.expiredAt) < new Date() || removeAnyWayMessage === 'removeAnyWayDialog'))
            onConfirm(true)
        else
            onConfirm(false)
    }

    const handleConfirmRemoveUserAnyWay = () => {
        onConfirm(true)
    }

    // const handleRemoveOrExit = async (removeAllNots) => {
    //     let url ;
    //     if (removeAllNots === 'removeAllNotifications')
    //         url =  '/api/devices/deleteAllWS'
    //     else if (endpoint === 'notificationsWS')
    //         url = '/api/devices/deleteLastWS'
    //     else
    //         url = `/api/${endpoint}/${itemId}`;
    //     const header = endpoint === 'notificationsWS' ?
    //         {'Content-Type': 'application/json',}
    //         :
    //         { 'Content-Type': 'application/json',
    //             'X-Auth-Token': 'Bearer ' + storedValue,
    //         };
    //     const body = endpoint === 'notificationsWS' ? JSON.stringify(sortedNotifications.map(item => item.id)) : password;
    //     // if (endpoint === 'exit') {
    //     //     handleLogout()
    //     // }
    //     // else {
    //     //      endpoint !== 'notificationsWS' && setLoading(true);
    //     try {
    //         const response = await fetch(url, {
    //             method: 'DELETE',
    //             headers: header,
    //             body: body
    //         });
    //         // if (response)
    //         //     setLoading(false)
    //         if (response.ok) {
    //             const contentType = response.headers.get("Content-Type")
    //             handleCloseDialog(!contentType?.includes("application/json"));
    //             if ( removeAllNots === 'removeAllNotifications')
    //                 dispatch(notificationsActions.clearNotifications());
    //             else if (endpoint === 'notificationsWS')
    //                 dispatch(notificationsActions.refreshNotifications(await response.json()))
    //             else if (endpoint === 'devices')
    //                 dispatch(devicesActions.remove(itemId))
    //         }
    //         else if (response.status === 400) {
    //             const errorText = await response.text();
    //             let spliteText = errorText.split(' ')[0];
    //             // setOpenSnackbar(spliteText)
    //         }
    //         else {
    //             // setOpenSnackbar('UnknownProblem')
    //         }             }
    //     catch (e) {
    //         // setLoading(false)
    //         // setOpenSnackbar('UnknownProblem')
    //         console.error('Fetch error:', e.message);
    //     }
    //     // }
    // }

    return (
        <>
            <Dialog classes={{ paper: classes.paperRemoveDialog }} open={open} onClose={() => handleCloseDialog(false)}>
                <div className={classes.content}>
                    <WarningRoundedIcon className={classes.iconRemoveDialog} />

                    <Typography variant="body1" className={classes.dialogMessage}>
                        {showedMessage()}
                    </Typography>

                    {endpoint === "devices" &&
                        <TextField
                            className={classes.textField}
                            value={password || ''}
                            onChange={(e) => setPassword(e.target.value)}
                            label={t("userPassword")}
                            variant="outlined"
                            size="small"
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleTogglePasswordVisibility} edge="end" size="small">
                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    }
                </div>

                <DialogActions className={classes.actions}>
                    <Button
                        type="button"
                        variant="outlined"
                        className={`${classes.cyberButtonRemoveDialog} ${classes.saveButtonRemoveDialog}`}
                        onClick={() => handleCancel()}
                    >
                        {cancelOrStay()}
                    </Button>
                    {endpoint === "notificationsWS" &&
                        <Button
                            type="button"
                            variant="outlined"
                            className={classes.cyberButtonSecondary}
                            onClick={handleRemoveAllNots}
                        >
                            {t('RemoveAll')}
                        </Button>
                    }
                    <Button
                        type="button"
                        variant="outlined"
                        className={classes.cyberButtonSecondary}
                        onClick={handleConfirm}
                    >
                        {confirmButtom()}
                    </Button>
                    {user.administrator && endpoint === 'users' &&
                        <Button
                            type="button"
                            variant="outlined"
                            className={`${classes.cyberButtonRemoveDialog} ${classes.removeButton}`}
                            onClick={handleConfirmRemoveUserAnyWay}
                        >
                            Remove Any Way
                        </Button>}
                    {/*{endpoint === "devices" && (new Date(device?.expiredAt) < new Date() || removeAnyWayMessage === 'removeAnyWayDialog') &&*/}
                    {/*    <Button style={{color: 'red', fontWeight: 'bold'}} onClick={() => onConfirm(true)}>*/}
                    {/*    removeAnyWay*/}
                    {/*</Button>}*/}
                </DialogActions>
            </Dialog>

            <Portal>
                <Snackbar open={!!openSnackbar} autoHideDuration={12000} onClose={handleCloseSnackbar} >
                    <Alert onClose={handleCloseSnackbar} variant="filled" severity="error" style={{ backgroundColor: '#ff4d4d' }}>
                        {t(openSnackbar)}
                    </Alert>
                </Snackbar>
            </Portal>

            {loading && (
                <div className={classes.loadingRemoveDialog}>
                    <CircularProgress style={{ color: '#00f2ff' }} size={60} thickness={4}/>
                </div>
            )}
        </>
    );
};

export default React.memo(RemoveDialog);